import React, {useEffect} from 'react';
import './career.scss';
import Breadcrumbs from "../../Components/Breadcrumbs/Breadcrumbs";
import HexadButton from "../../Components/HexadButton/HexadButton";
import careerImage from '../../styles/images/Hexad-office-bcn(4).jpg';
import {useTranslation} from "react-i18next";

const Career = () => {
    const { t } = useTranslation();
    const imageText = t('ImageText1') + t('ImageText2');
    const linkedinCareerPageLink = t('SeeJobsLink');

    useEffect(() => {
        window.scrollTo(0, 0)
    }, []);

    return (
        <div id={'career'}>
            <div className={'top-area'}/>
            <div className="career-container hero-container">
                <div
                    className={'career-content responsive-container responsive-container__slimmer'}>
                    <Breadcrumbs/>
                    <h3>{t('Career')}</h3>
                    <p>{t('LikeWhatYouSaw')}</p>
                    <HexadButton text={t('SeeJobs')}
                                 link={linkedinCareerPageLink} inverted
                                 external/>
                    <p>{t('SendYourCV')}
                        <a style={{ color: 'orange' }}
                           href="mailto:hr@hexad.es">
                            hr@hexad.es</a>

                    </p>
                </div>

                <div className={'career-image'}>
                    <div className="headline-container">
                        <h4 className={'headline'}>{imageText}</h4>
                    </div>
                    <div className={'overlay'}/>
                    {/* eslint-disable-next-line*/}
                    <img className={'background'} src={careerImage}
                         alt="career image"/>
                </div>
            </div>
        </div>
    )
}

export default Career;